import { render, staticRenderFns } from "./PageNewGood.vue?vue&type=template&id=059d2de6&"
import script from "./PageNewGood.vue?vue&type=script&lang=js&"
export * from "./PageNewGood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports